import { lazy } from "react"
import { COMPANY_BASE_ROLES_VALUES } from "@/shared/constants"
import type { CustomRoute } from "@/shared/types"

const OtmComponent = lazy(() => import("@/pages/dashboard/otm-page"))

export const otmRoutes: CustomRoute = {
  path: "otm",
  handle: {
    label: "OTM",
    icon: "CheckMarkSquare03",
    i18Key: "otm",
    ignoreChildren: true,
    allowedRoles: COMPANY_BASE_ROLES_VALUES
  },
  Component: OtmComponent
}
